import React, { createContext, useContext, useState, useMemo } from 'react';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useKeycodeListener } from '@shared/utils/hooks/useKeycodeListener';

type HotelOfferDiagnosticsContextValue = Readonly<{
  showMargin: boolean;
  showProviderName: boolean;
}>;

const HotelOfferDiagnosticsContext = createContext<HotelOfferDiagnosticsContextValue>({
  showMargin: false,
  showProviderName: false,
});

const MARGIN_HOTKEYS = ['M'] as const;
const PROVIDER_HOTKEYS = ['H'] as const;
const HOTKEY_OPTIONS = { ctrlKey: true, shiftKey: true };

export const HotelOfferDiagnosticsProvider = ({ children }: Readonly<{ children: React.ReactNode }>) => {
  const [showMargin, setShowMargin] = useState(false);
  const [showProviderName, setShowProviderName] = useState(false);

  const toggleMargin = useEventCallback(() => setShowMargin(prev => !prev));
  const toggleProviderName = useEventCallback(() => setShowProviderName(prev => !prev));

  useKeycodeListener(MARGIN_HOTKEYS, toggleMargin, HOTKEY_OPTIONS);
  useKeycodeListener(PROVIDER_HOTKEYS, toggleProviderName, HOTKEY_OPTIONS);

  const value = useMemo(() => ({ showMargin, showProviderName }), [showMargin, showProviderName]);

  return <HotelOfferDiagnosticsContext.Provider value={value}>{children}</HotelOfferDiagnosticsContext.Provider>;
};

export const useHotelOfferDiagnostics = () => useContext(HotelOfferDiagnosticsContext);
